<template>
  <div class="hello">
    <ul>
      <li v-for="(step, index) in steps">
        <router-link v-if="!step.isOption" :to="{ name: 'Question', params: { id: step.id } }">
          <span class="index"> {{ index + 1}} </span>
          {{ step.title }}
          <span class="go-icon">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </span>
        </router-link>

        <router-link v-if="step.isOption" :to="{ name: 'Option', params: { id: step.id } }">
          <span class="index"> {{ index + 1}} </span>
          {{ step.title }}
          <span class="go-icon">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </span>
        </router-link>
      </li>

      <li v-if="information" class="information">
        <p v-html="information">
        </p>
      </li>
    </ul>

    <router-link class="not-these" :to="{ name: 'Contact', query: { gim: '1' }}">
      Bunların Dışında
      <span class="go-icon">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Option',
  data() {
    return {
      information: false,
      steps: [],
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route() {
      this.fetchData();
    },
  },
  methods: {
    fetchData() {
      // 4.5g Ayarları
      if (this.$route.params.id == 1) {
        this.steps = [
          {
            title: 'Venus v3 (5040, 5070, 5570)',
            id: 3,
            isOption: false,
          },
          {
            title: 'Venus 5.5',
            id: 10,
            isOption: false,
          },
        ];
      }

      // Durum Sorgulama
      if (this.$route.params.id == 2) {
        this.information = '<b>Talep No Nedir?:</b> Daha önce Vestel Yetkili Servislerimiz aracılığıyla Vestel ürünleriniz için hizmet almış iseniz aldığınız hizmet sonunda size bırakılan servis fişinin üzerinde ya da sistemimizde kayıtlı olan cep telefonunuza gönderilmiş olan SMS’in içerisinde 8 ile başlayan numaradır.';
        this.steps = [
          {
            title: 'Hizmet Talep No, Seri No veya IMEI no ile sorgulama',
            id: 30,
            isOption: false,
          },
        ];
      }

      // Fabrika Ayarlarına Döndürmek İçin
      if (this.$route.params.id == 90) {
        this.steps = [
          {
            title: 'Venus için',
            id: 91,
            isOption: false,
          },
          {
            title: 'Tablet için',
            id: 92,
            isOption: false,
          },
        ];
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
    width: 100%;
    margin: 0;
    max-height: 320px;
    overflow-y: scroll;
  }

  li {
    display: block;
    text-align: left;
    padding: 0 15px;

    &::after {
      content: '';
      width: 100%;
      background-color: #E0E0E0;
      opacity: 0.6;
      height: 1px;
      display: block;
      margin: 15px auto;
    }

    &.information {
      font-size: 13px;
      color: #8e8e8e;
    }
  }

  .not-these {
    text-decoration: none;
    display: block;
    clear: both;
    margin: 20px auto;
    width: 85%;
    box-sizing: border-box;
    padding: 15px 20px;
    text-align: left;
    font-size: 14px;
    background: #3586ad;
    color: #fff;
    border-radius: 4px;
    box-shadow: 0px 5px 20px 0 rgba(0, 0, 0, 0.2);

    i {
      float: right;
    }
  }

  li a {
    font-size: 15px;
    color: #858484;
    letter-spacing: 0;
    line-height: 20px;
    text-decoration: none;
    display: block;
    position: relative;
    padding: 0 25px;

    &:hover {

      .index {
        transform: translateY(-50%) rotate(0deg);
      }

      .go-icon {
        right: 5px;
        opacity: 1;
      }
    }

    .index {
      position: absolute;
      opacity: 0.4;
      font-size: 19px;
      color: #858484;
      left: 0;
      top: 50%;
      transform: translateY(-50%) rotate(10deg);
      transition: all 0.5s;
    }

    .go-icon {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      transition: all 0.5s;
      font-size: 13px;
      opacity: 0.6;
    }
  }
</style>



// WEBPACK FOOTER //
// Option.vue?7157c7cd